module.exports = {
  "data": {
    "id": "lp1897",
    "name": "The Manhattan at Times Square",
    "hotelDescription": "<p><strong>Central Manhattan Location</strong><br>The Manhattan at Times Square is perfectly situated in the heart of Manhattan, just steps away from iconic landmarks like Times Square and Rockefeller Centre.</p><p><strong>Comfortable Accommodations</strong><br>Each room at The Manhattan at Times Square is equipped with a work desk, and select rooms boast stunning skyline views and a cozy seating area for relaxation.</p><p><strong>Convenient Amenities</strong><br>Guests can enjoy a range of amenities at The Manhattan at Times Square, including a fitness centre, a business centre with fax and photocopying services, and attentive concierge services.</p><p>Book your stay at The Manhattan at Times Square to experience the best of New York City right at your doorstep.</p>",
    "hotelImportantInformation": "Guests are required to show a photo identification and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.\nIn response to Coronavirus (COVID-19), additional safety and sanitation measures are in effect at this property.\nPlease inform The Manhattan at Times Square in advance of your expected arrival time. You can use the Special Requests box when booking, or contact the property directly with the contact details provided in your confirmation.\nA damage deposit of USD 50 is required on arrival. This will be collected by credit card. You should be reimbursed on check-out. Your deposit will be refunded in full via credit card, subject to an inspection of the property.\nPlease note that the Manhattan at Times Square Hotel has a mandatory Facilities Fee of $43.61 per room per night provides guests with the following inclusive services, amenities and added value offerings:\n\nAll local, long distance and international phone calls\nPremium high-speed wireless internet access for unlimited devices\nAn eco-friendly, collapsible 16 oz. water bottle to use at the hotel's water filtration stations\nUnlimited use of our Business Center\nUnlimited use of our 24/7 Fitness Center with treadmills, bikes, elliptical machines and free weights\n25% discount on hop on/hop off bus tour with provided QR code\n*The Facilities Fee does not include service gratuity",
    "checkinCheckoutTimes": {
      "checkout": "11:00 AM",
      "checkin_start": "04:00 PM",
      "checkin_end": "12:00 AM",
      "instructions": [],
      "special_instructions": ""
    },
    "hotelImages": [
      {
        "url": "https://static.cupid.travel/hotels/524489007.jpg",
        "urlHd": "https://static.cupid.travel/hotels/524489007.jpg",
        "caption": "",
        "order": 0,
        "defaultImage": true
      },
      {
        "url": "https://static.cupid.travel/hotels/333925043.jpg",
        "urlHd": "https://static.cupid.travel/hotels/333925043.jpg",
        "caption": "",
        "order": 0,
        "defaultImage": false
      },
      {
        "url": "https://static.cupid.travel/hotels/40322143.jpg",
        "urlHd": "https://static.cupid.travel/hotels/40322143.jpg",
        "caption": "",
        "order": 0,
        "defaultImage": false
      },
      {
        "url": "https://static.cupid.travel/hotels/333925055.jpg",
        "urlHd": "https://static.cupid.travel/hotels/333925055.jpg",
        "caption": "",
        "order": 0,
        "defaultImage": false
      }
    ],
    "main_photo": "https://static.cupid.travel/hotels/524489007.jpg",
    "thumbnail": "https://static.cupid.travel/hotels/thumbnail/524489007.jpg",
    "videoUrl": "https://static.nuitee.cloud/videos/lp2957f.mp4",
    "country": "us",
    "city": "New York",
    "starRating": 4,
    "location": {
      "latitude": 40.76217,
      "longitude": -73.98306
    },
    "address": "790 7th Avenue",
    "hotelFacilities": [
      "Fitness facilities (surcharge)",
      "Non-smoking rooms",
      "Air conditioning",
      "Family rooms",
      "Pets allowed",
      "Lift / Elevator",
      "Luggage storage",
      "Express check-in/check-out",
      "Safety deposit box",
      "Fax/photocopying",
      "Soundproof rooms",
      "Facilities for disabled guests",
      "Ironing service",
      "Non-smoking throughout",
      "Private check-in/check-out",
      "Staff adhere to local safety protocols",
      "Guest rooms disinfected between stays",
      "Cleaning standards that are effective against Coronavirus",
      "Physical distancing rules followed",
      "Hand sanitizer in guest room and key areas",
      "Cashless payment available",
      "Fire extinguishers",
      "First aid kit available",
      "Sanitized tableware & silverware",
      "Contactless check-in/check-out",
      "Invoice provided",
      "Guests can opt-out any cleaning services during stay",
      "Smoke alarms",
      "Shared stationery like menus, pens are removed",
      "Guest room sealed after cleaning",
      "Property cleaned by professional cleaning companies",
      "Physical distancing in dining areas",
      "Key access",
      "Food delivered to guest room",
      "CCTV outside property",
      "Process in place to check health of guests",
      "Screens / Barriers between staff and guests for safety",
      "Face masks for guests available",
      "24-hour security",
      "Delivered food - securely covered",
      "Security alarm",
      "Key card access",
      "ATM/banking",
      "Shopping on site",
      "Television in common areas",
      "Front desk (limited hours)",
      "Express check-in",
      "Free wired internet",
      "Fitness facilities (surcharge)",
      "Internet access",
      "Housekeeping on request",
      "Covered parking",
      "Secured parking",
      "Garage"
    ],
    "chain": "Not Available",
    "facilities": [
      {
        "facilityId": 6848,
        "name": "Fitness facilities (surcharge)"
      },
      {
        "facilityId": 16,
        "name": "Non-smoking rooms"
      },
      {
        "facilityId": 109,
        "name": "Air conditioning"
      },
      {
        "facilityId": 28,
        "name": "Family rooms"
      },
      {
        "facilityId": 4,
        "name": "Pets allowed"
      },
      {
        "facilityId": 48,
        "name": "Lift / Elevator"
      },
      {
        "facilityId": 91,
        "name": "Luggage storage"
      },
      {
        "facilityId": 49,
        "name": "Express check-in/check-out"
      },
      {
        "facilityId": 51,
        "name": "Safety deposit box"
      },
      {
        "facilityId": 81,
        "name": "Fax/photocopying"
      },
      {
        "facilityId": 64,
        "name": "Soundproof rooms"
      },
      {
        "facilityId": 25,
        "name": "Facilities for disabled guests"
      },
      {
        "facilityId": 44,
        "name": "Ironing service"
      },
      {
        "facilityId": 108,
        "name": "Non-smoking throughout"
      },
      {
        "facilityId": 127,
        "name": "Private check-in/check-out"
      },
      {
        "facilityId": 455,
        "name": "Staff adhere to local safety protocols"
      },
      {
        "facilityId": 451,
        "name": "Guest rooms disinfected between stays"
      },
      {
        "facilityId": 449,
        "name": "Cleaning standards that are effective against Coronavirus"
      },
      {
        "facilityId": 462,
        "name": "Physical distancing rules followed"
      },
      {
        "facilityId": 457,
        "name": "Hand sanitizer in guest room and key areas"
      },
      {
        "facilityId": 461,
        "name": "Cashless payment available"
      },
      {
        "facilityId": 425,
        "name": "Fire extinguishers"
      },
      {
        "facilityId": 459,
        "name": "First aid kit available"
      },
      {
        "facilityId": 467,
        "name": "Sanitized tableware & silverware"
      },
      {
        "facilityId": 460,
        "name": "Contactless check-in/check-out"
      },
      {
        "facilityId": 465,
        "name": "Invoice provided"
      },
      {
        "facilityId": 468,
        "name": "Guests can opt-out any cleaning services during stay"
      },
      {
        "facilityId": 422,
        "name": "Smoke alarms"
      },
      {
        "facilityId": 456,
        "name": "Shared stationery like menus, pens are removed"
      },
      {
        "facilityId": 452,
        "name": "Guest room sealed after cleaning"
      },
      {
        "facilityId": 466,
        "name": "Property cleaned by professional cleaning companies"
      },
      {
        "facilityId": 453,
        "name": "Physical distancing in dining areas"
      },
      {
        "facilityId": 419,
        "name": "Key access"
      },
      {
        "facilityId": 454,
        "name": "Food delivered to guest room"
      },
      {
        "facilityId": 424,
        "name": "CCTV outside property"
      },
      {
        "facilityId": 458,
        "name": "Process in place to check health of guests"
      },
      {
        "facilityId": 464,
        "name": "Screens / Barriers between staff and guests for safety"
      },
      {
        "facilityId": 488,
        "name": "Face masks for guests available"
      },
      {
        "facilityId": 418,
        "name": "24-hour security"
      },
      {
        "facilityId": 485,
        "name": "Delivered food - securely covered"
      },
      {
        "facilityId": 421,
        "name": "Security alarm"
      },
      {
        "facilityId": 420,
        "name": "Key card access"
      },
      {
        "facilityId": 497,
        "name": "ATM/banking"
      },
      {
        "facilityId": 500,
        "name": "Shopping on site"
      },
      {
        "facilityId": 521,
        "name": "Television in common areas"
      },
      {
        "facilityId": 540,
        "name": "Front desk (limited hours)"
      },
      {
        "facilityId": 568,
        "name": "Express check-in"
      },
      {
        "facilityId": 584,
        "name": "Free wired internet"
      },
      {
        "facilityId": 757,
        "name": "Fitness facilities (surcharge)"
      },
      {
        "facilityId": 761,
        "name": "Internet access"
      },
      {
        "facilityId": 784,
        "name": "Housekeeping on request"
      },
      {
        "facilityId": 857,
        "name": "Covered parking"
      },
      {
        "facilityId": 859,
        "name": "Secured parking"
      },
      {
        "facilityId": 880,
        "name": "Garage"
      }
    ],
    "rooms": [
      {
        "id": 2617264,
        "roomName": "Standard Room",
        "description": "The double room includes a private bathroom equipped with a hairdryer. The air-conditioned double room provides a TV with satellite channels, soundproof walls, a safe deposit box, heating as well as city views.",
        "roomSizeSquare": 23,
        "roomSizeUnit": "m2",
        "hotelId": "436827",
        "maxAdults": 2,
        "maxChildren": 1,
        "maxOccupancy": 2,
        "bedTypes": [],
        "roomAmenities": [
          {
            "amenitiesId": 293,
            "name": "Safety deposit box",
            "sort": 17
          },
          {
            "amenitiesId": 339,
            "name": "TV",
            "sort": 0
          },
          {
            "amenitiesId": 342,
            "name": "Telephone",
            "sort": 0
          },
          {
            "amenitiesId": 11,
            "name": "Air conditioning",
            "sort": 0
          },
          {
            "amenitiesId": 148,
            "name": "Hair dryer",
            "sort": 0
          },
          {
            "amenitiesId": 350,
            "name": "Toilet",
            "sort": 10
          },
          {
            "amenitiesId": 266,
            "name": "Private bathroom",
            "sort": 0
          },
          {
            "amenitiesId": 156,
            "name": "Heating",
            "sort": 0
          },
          {
            "amenitiesId": 295,
            "name": "Satellite channels",
            "sort": 20
          },
          {
            "amenitiesId": 176,
            "name": "Interconnected room(s) available",
            "sort": 63
          },
          {
            "amenitiesId": 371,
            "name": "View",
            "sort": 31
          },
          {
            "amenitiesId": 57,
            "name": "City view",
            "sort": 39
          },
          {
            "amenitiesId": 197,
            "name": "Linen",
            "sort": 43
          },
          {
            "amenitiesId": 366,
            "name": "Upper floors accessible by elevator",
            "sort": 166
          },
          {
            "amenitiesId": 352,
            "name": "Toilet paper",
            "sort": 0
          },
          {
            "amenitiesId": 361,
            "name": "Trash cans",
            "sort": 85
          },
          {
            "amenitiesId": 327,
            "name": "Socket near the bed",
            "sort": 89
          },
          {
            "amenitiesId": 5,
            "name": "Accessible by lift",
            "sort": 29
          },
          {
            "amenitiesId": 322,
            "name": "Smoke alarm",
            "sort": 182
          },
          {
            "amenitiesId": 182,
            "name": "Key card access",
            "sort": 158
          }
        ],
        "photos": [
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/592392806.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/592392806.jpg?k=a4eb5eb9a6a889c0de416084b723b6697b3c5d2c84bd81413c95734b671aa6e1&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/592392806.jpg"
          }
        ]
      },
      {
        "id": 2617265,
        "roomName": "Premium Room",
        "description": "The double room includes a private bathroom fitted with a hairdryer. The spacious air-conditioned double room offers a TV with satellite channels, soundproof walls, a safe deposit box, heating as well as city views.",
        "roomSizeSquare": 26,
        "roomSizeUnit": "m2",
        "hotelId": "436827",
        "maxAdults": 2,
        "maxChildren": 1,
        "maxOccupancy": 2,
        "bedTypes": [],
        "roomAmenities": [
          {
            "amenitiesId": 293,
            "name": "Safety deposit box",
            "sort": 17
          },
          {
            "amenitiesId": 339,
            "name": "TV",
            "sort": 0
          },
          {
            "amenitiesId": 342,
            "name": "Telephone",
            "sort": 0
          },
          {
            "amenitiesId": 11,
            "name": "Air conditioning",
            "sort": 0
          },
          {
            "amenitiesId": 148,
            "name": "Hair dryer",
            "sort": 0
          },
          {
            "amenitiesId": 350,
            "name": "Toilet",
            "sort": 10
          },
          {
            "amenitiesId": 266,
            "name": "Private bathroom",
            "sort": 0
          },
          {
            "amenitiesId": 156,
            "name": "Heating",
            "sort": 0
          },
          {
            "amenitiesId": 295,
            "name": "Satellite channels",
            "sort": 20
          },
          {
            "amenitiesId": 176,
            "name": "Interconnected room(s) available",
            "sort": 63
          },
          {
            "amenitiesId": 371,
            "name": "View",
            "sort": 31
          },
          {
            "amenitiesId": 57,
            "name": "City view",
            "sort": 39
          },
          {
            "amenitiesId": 197,
            "name": "Linen",
            "sort": 43
          },
          {
            "amenitiesId": 366,
            "name": "Upper floors accessible by elevator",
            "sort": 166
          },
          {
            "amenitiesId": 352,
            "name": "Toilet paper",
            "sort": 0
          },
          {
            "amenitiesId": 361,
            "name": "Trash cans",
            "sort": 85
          },
          {
            "amenitiesId": 327,
            "name": "Socket near the bed",
            "sort": 89
          },
          {
            "amenitiesId": 5,
            "name": "Accessible by lift",
            "sort": 29
          },
          {
            "amenitiesId": 322,
            "name": "Smoke alarm",
            "sort": 182
          },
          {
            "amenitiesId": 182,
            "name": "Key card access",
            "sort": 158
          }
        ],
        "photos": [
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/527434935.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/527434935.jpg?k=c0d05d76c837a33c0df60899e25feb97cf8fecf8b89244422e63bdef2203157b&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/527434935.jpg"
          },
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/524489119.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/524489119.jpg?k=0488a1da0924228e67bbd3df87c868a9d7d5019bb42cdfaf7a395dc2d4cab9df&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/524489119.jpg"
          },
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/524489114.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/524489114.jpg?k=d2855ccba7916212023cfa373066f32eafb4d6b7ea5e98b3e74440fccd53df24&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/524489114.jpg"
          }
        ]
      },
      {
        "id": 2617266,
        "roomName": "Standard Queen Room",
        "description": "The double room includes a private bathroom fitted with a hairdryer. The air-conditioned double room offers a TV with satellite channels, soundproof walls, a safe deposit box, heating as well as city views. The unit has 1 bed.",
        "roomSizeSquare": 23,
        "roomSizeUnit": "m2",
        "hotelId": "436827",
        "maxAdults": 2,
        "maxChildren": 1,
        "maxOccupancy": 2,
        "bedTypes": [
          {
            "quantity": 1,
            "bedType": "Large bed (King size)",
            "bedSize": "151-180cm wide"
          }
        ],
        "roomAmenities": [
          {
            "amenitiesId": 293,
            "name": "Safety deposit box",
            "sort": 17
          },
          {
            "amenitiesId": 339,
            "name": "TV",
            "sort": 0
          },
          {
            "amenitiesId": 342,
            "name": "Telephone",
            "sort": 0
          },
          {
            "amenitiesId": 11,
            "name": "Air conditioning",
            "sort": 0
          },
          {
            "amenitiesId": 148,
            "name": "Hair dryer",
            "sort": 0
          },
          {
            "amenitiesId": 350,
            "name": "Toilet",
            "sort": 10
          },
          {
            "amenitiesId": 266,
            "name": "Private bathroom",
            "sort": 0
          },
          {
            "amenitiesId": 156,
            "name": "Heating",
            "sort": 0
          },
          {
            "amenitiesId": 295,
            "name": "Satellite channels",
            "sort": 20
          },
          {
            "amenitiesId": 371,
            "name": "View",
            "sort": 31
          },
          {
            "amenitiesId": 57,
            "name": "City view",
            "sort": 39
          },
          {
            "amenitiesId": 197,
            "name": "Linen",
            "sort": 43
          },
          {
            "amenitiesId": 366,
            "name": "Upper floors accessible by elevator",
            "sort": 166
          },
          {
            "amenitiesId": 352,
            "name": "Toilet paper",
            "sort": 0
          },
          {
            "amenitiesId": 361,
            "name": "Trash cans",
            "sort": 85
          },
          {
            "amenitiesId": 327,
            "name": "Socket near the bed",
            "sort": 89
          },
          {
            "amenitiesId": 5,
            "name": "Accessible by lift",
            "sort": 29
          },
          {
            "amenitiesId": 322,
            "name": "Smoke alarm",
            "sort": 182
          },
          {
            "amenitiesId": 182,
            "name": "Key card access",
            "sort": 158
          }
        ],
        "photos": [
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/528870978.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/528870978.jpg?k=ebb8f0bb34ad36718ced190d11fddd683a61100ac95a3b5fdf1f5c0194a5194d&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/528870978.jpg"
          },
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/524489106.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/524489106.jpg?k=438c14c18623b4c6ce67ba8b3b1343ce591f873ffd5940e34d1255a26a88ef4d&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/524489106.jpg"
          },
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/524489112.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/524489112.jpg?k=5248c6024a1447a7dca20dccf2933f81618f401dc809b0a4e3427403760ecab8&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/524489112.jpg"
          }
        ]
      },
      {
        "id": 2617267,
        "roomName": "Standard King Room",
        "description": "The double room includes a private bathroom fitted with a hairdryer. The spacious air-conditioned double room features a TV with satellite channels, soundproof walls, a safe deposit box, heating as well as city views. The unit has 1 bed.",
        "roomSizeSquare": 26,
        "roomSizeUnit": "m2",
        "hotelId": "436827",
        "maxAdults": 2,
        "maxChildren": 1,
        "maxOccupancy": 2,
        "bedTypes": [
          {
            "quantity": 1,
            "bedType": "Extra-large double bed (Super-king size)",
            "bedSize": "181-210 cm wide"
          }
        ],
        "roomAmenities": [
          {
            "amenitiesId": 293,
            "name": "Safety deposit box",
            "sort": 17
          },
          {
            "amenitiesId": 339,
            "name": "TV",
            "sort": 0
          },
          {
            "amenitiesId": 342,
            "name": "Telephone",
            "sort": 0
          },
          {
            "amenitiesId": 11,
            "name": "Air conditioning",
            "sort": 0
          },
          {
            "amenitiesId": 148,
            "name": "Hair dryer",
            "sort": 0
          },
          {
            "amenitiesId": 350,
            "name": "Toilet",
            "sort": 10
          },
          {
            "amenitiesId": 266,
            "name": "Private bathroom",
            "sort": 0
          },
          {
            "amenitiesId": 156,
            "name": "Heating",
            "sort": 0
          },
          {
            "amenitiesId": 295,
            "name": "Satellite channels",
            "sort": 20
          },
          {
            "amenitiesId": 176,
            "name": "Interconnected room(s) available",
            "sort": 63
          },
          {
            "amenitiesId": 371,
            "name": "View",
            "sort": 31
          },
          {
            "amenitiesId": 57,
            "name": "City view",
            "sort": 39
          },
          {
            "amenitiesId": 197,
            "name": "Linen",
            "sort": 43
          },
          {
            "amenitiesId": 366,
            "name": "Upper floors accessible by elevator",
            "sort": 166
          },
          {
            "amenitiesId": 352,
            "name": "Toilet paper",
            "sort": 0
          },
          {
            "amenitiesId": 361,
            "name": "Trash cans",
            "sort": 85
          },
          {
            "amenitiesId": 327,
            "name": "Socket near the bed",
            "sort": 89
          },
          {
            "amenitiesId": 5,
            "name": "Accessible by lift",
            "sort": 29
          },
          {
            "amenitiesId": 322,
            "name": "Smoke alarm",
            "sort": 182
          },
          {
            "amenitiesId": 182,
            "name": "Key card access",
            "sort": 158
          }
        ],
        "photos": [
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/528870820.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/528870820.jpg?k=34baac1cd0442eaa0a3b12df5b678ab61f22c64d8c396dc8e470a8656b921a6e&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/528870820.jpg"
          },
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/528870858.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/528870858.jpg?k=8a70f991486b34ba08fa88c9d18583b6b35d83f9bef71129157a8b625fa683af&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/528870858.jpg"
          },
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/524489106.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/524489106.jpg?k=438c14c18623b4c6ce67ba8b3b1343ce591f873ffd5940e34d1255a26a88ef4d&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/524489106.jpg"
          },
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/524489133.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/524489133.jpg?k=8a31e539abdd92ca9b544a7b1b162c85483dd28611cd8f62f8a5d7411dad32a8&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/524489133.jpg"
          },
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/524489112.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/524489112.jpg?k=5248c6024a1447a7dca20dccf2933f81618f401dc809b0a4e3427403760ecab8&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/524489112.jpg"
          },
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/524489116.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/524489116.jpg?k=03e55f2f056007a3c9d123d1590a7349b4fffd8fe95a6b34c1bb12502ebd928f&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/524489116.jpg"
          }
        ]
      },
      {
        "id": 2617268,
        "roomName": "Standard Double Room with Two Double Beds",
        "description": "The double room includes a private bathroom equipped with a hairdryer. The spacious air-conditioned double room offers a TV with satellite channels, soundproof walls, a safe deposit box, heating as well as city views. The unit offers 2 beds.",
        "roomSizeSquare": 27,
        "roomSizeUnit": "m2",
        "hotelId": "436827",
        "maxAdults": 4,
        "maxChildren": 3,
        "maxOccupancy": 4,
        "bedTypes": [
          {
            "quantity": 2,
            "bedType": "Double bed",
            "bedSize": "131-150 cm wide"
          }
        ],
        "roomAmenities": [
          {
            "amenitiesId": 293,
            "name": "Safety deposit box",
            "sort": 17
          },
          {
            "amenitiesId": 339,
            "name": "TV",
            "sort": 0
          },
          {
            "amenitiesId": 342,
            "name": "Telephone",
            "sort": 0
          },
          {
            "amenitiesId": 11,
            "name": "Air conditioning",
            "sort": 0
          },
          {
            "amenitiesId": 148,
            "name": "Hair dryer",
            "sort": 0
          },
          {
            "amenitiesId": 350,
            "name": "Toilet",
            "sort": 10
          },
          {
            "amenitiesId": 266,
            "name": "Private bathroom",
            "sort": 0
          },
          {
            "amenitiesId": 156,
            "name": "Heating",
            "sort": 0
          },
          {
            "amenitiesId": 295,
            "name": "Satellite channels",
            "sort": 20
          },
          {
            "amenitiesId": 176,
            "name": "Interconnected room(s) available",
            "sort": 63
          },
          {
            "amenitiesId": 371,
            "name": "View",
            "sort": 31
          },
          {
            "amenitiesId": 57,
            "name": "City view",
            "sort": 39
          },
          {
            "amenitiesId": 197,
            "name": "Linen",
            "sort": 43
          },
          {
            "amenitiesId": 366,
            "name": "Upper floors accessible by elevator",
            "sort": 166
          },
          {
            "amenitiesId": 352,
            "name": "Toilet paper",
            "sort": 0
          },
          {
            "amenitiesId": 361,
            "name": "Trash cans",
            "sort": 85
          },
          {
            "amenitiesId": 327,
            "name": "Socket near the bed",
            "sort": 89
          },
          {
            "amenitiesId": 5,
            "name": "Accessible by lift",
            "sort": 29
          },
          {
            "amenitiesId": 322,
            "name": "Smoke alarm",
            "sort": 182
          },
          {
            "amenitiesId": 182,
            "name": "Key card access",
            "sort": 158
          }
        ],
        "photos": [
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/524489112.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/524489112.jpg?k=5248c6024a1447a7dca20dccf2933f81618f401dc809b0a4e3427403760ecab8&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/524489112.jpg"
          },
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/524489056.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/524489056.jpg?k=6e138c72f652812bde87f44ebf164ec3a2085ed10650caa87e0a4ce4e8ee9b0b&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/524489056.jpg"
          },
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/524489039.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/524489039.jpg?k=8670f0f6b3e0888d7714dd4da3ba9a7d422e21b2580d066593e2c281161ea5dd&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/524489039.jpg"
          }
        ]
      },
      {
        "id": 2617269,
        "roomName": "Premium Queen Room - Manhattan Floor",
        "description": "The double room features air conditioning, soundproof walls, as well as a private bathroom boasting a walk-in shower and a hairdryer. The unit has 1 bed.",
        "roomSizeSquare": 23,
        "roomSizeUnit": "m2",
        "hotelId": "436827",
        "maxAdults": 2,
        "maxChildren": 1,
        "maxOccupancy": 2,
        "bedTypes": [
          {
            "quantity": 1,
            "bedType": "Large bed (King size)",
            "bedSize": "151-180cm wide"
          }
        ],
        "roomAmenities": [
          {
            "amenitiesId": 293,
            "name": "Safety deposit box",
            "sort": 17
          },
          {
            "amenitiesId": 339,
            "name": "TV",
            "sort": 0
          },
          {
            "amenitiesId": 342,
            "name": "Telephone",
            "sort": 0
          },
          {
            "amenitiesId": 11,
            "name": "Air conditioning",
            "sort": 0
          },
          {
            "amenitiesId": 148,
            "name": "Hair dryer",
            "sort": 0
          },
          {
            "amenitiesId": 350,
            "name": "Toilet",
            "sort": 10
          },
          {
            "amenitiesId": 266,
            "name": "Private bathroom",
            "sort": 0
          },
          {
            "amenitiesId": 156,
            "name": "Heating",
            "sort": 0
          },
          {
            "amenitiesId": 295,
            "name": "Satellite channels",
            "sort": 20
          },
          {
            "amenitiesId": 371,
            "name": "View",
            "sort": 31
          },
          {
            "amenitiesId": 57,
            "name": "City view",
            "sort": 39
          },
          {
            "amenitiesId": 197,
            "name": "Linen",
            "sort": 43
          },
          {
            "amenitiesId": 366,
            "name": "Upper floors accessible by elevator",
            "sort": 166
          },
          {
            "amenitiesId": 352,
            "name": "Toilet paper",
            "sort": 0
          },
          {
            "amenitiesId": 361,
            "name": "Trash cans",
            "sort": 85
          },
          {
            "amenitiesId": 327,
            "name": "Socket near the bed",
            "sort": 89
          },
          {
            "amenitiesId": 5,
            "name": "Accessible by lift",
            "sort": 29
          },
          {
            "amenitiesId": 322,
            "name": "Smoke alarm",
            "sort": 182
          },
          {
            "amenitiesId": 182,
            "name": "Key card access",
            "sort": 158
          }
        ],
        "photos": [
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/527434935.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/527434935.jpg?k=c0d05d76c837a33c0df60899e25feb97cf8fecf8b89244422e63bdef2203157b&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/527434935.jpg"
          },
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/524489119.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/524489119.jpg?k=0488a1da0924228e67bbd3df87c868a9d7d5019bb42cdfaf7a395dc2d4cab9df&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/524489119.jpg"
          },
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/524489094.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/524489094.jpg?k=d06c959703dd03ad7dd5515a91601fcdb3e7ac0d66e494a46fa1ab566c01bd10&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/524489094.jpg"
          },
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/524489074.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/524489074.jpg?k=a95c4b2c1749966628b58726c5f75e6c1c0dc3147814f523cf2482a73cfcf063&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/524489074.jpg"
          },
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/524489112.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/524489112.jpg?k=5248c6024a1447a7dca20dccf2933f81618f401dc809b0a4e3427403760ecab8&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/524489112.jpg"
          },
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/523933085.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/523933085.jpg?k=b3dcaeea6fc047da6cc2e4ef9a1c43b17e71129e16662dc217b24384fc028cfb&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/523933085.jpg"
          },
          {
            "url": "https://static.cupid.travel/rooms-large-pictures/618690410.jpg",
            "imageDescription": "",
            "imageClass1": "",
            "imageClass2": "",
            "failoverPhoto": "https://q-xx.bstatic.com/xdata/images/hotel/max1200/618690410.jpg?k=9792a5c999a98b01daed4502de27f2edaecf8cc3b705ca6e0d4adfcc1ad62d4c&o=",
            "mainPhoto": false,
            "score": 0,
            "classId": 0,
            "classOrder": 0,
            "hd_url": "https://static.cupid.travel/rooms-large-pictures/618690410.jpg"
          }
        ]
      }
    ],
    "phone": "",
    "fax": "",
    "email": "",
    "hotelType": "Hotels",
    "hotelTypeId": 204,
    "airportCode": "LGA",
    "rating": 5.6,
    "reviewCount": 6536,
    "rohId": 20712,
    "parking": "",
    "groupRoomMin": 0,
    "childAllowed": false,
    "petsAllowed": false,
    "policies": [
      {
        "policy_type": "POLICY_HOTEL_GROUPS",
        "name": "Groups",
        "description": "When booking more than 5 rooms, different policies and additional supplements may apply.\n",
        "child_allowed": "",
        "pets_allowed": "",
        "parking": ""
      },
      {
        "policy_type": "POLICY_HOTEL_INTERNET",
        "name": "Internet",
        "description": "WiFi is available in public areas and is free of charge.\n",
        "child_allowed": "",
        "pets_allowed": "",
        "parking": ""
      },
      {
        "policy_type": "POLICY_HOTEL_PARKING",
        "name": "Parking",
        "description": "Public parking is possible on site (reservation is not needed) and costs  USD 72 per  day.\n",
        "child_allowed": "",
        "pets_allowed": "",
        "parking": ""
      },
      {
        "policy_type": "POLICY_HOTEL_PETS",
        "name": "Pets",
        "description": "Pets are allowed. Charges may be applicable.\n",
        "child_allowed": "",
        "pets_allowed": "",
        "parking": ""
      },
      {
        "policy_type": "POLICY_CHILDREN",
        "name": "Children and extra bed policy",
        "description": "Children of any age are allowed.\nChildren up to and including 17 years old stay for free when using an existing bed.\nYou haven't added any cots.\nYou haven't added any extra beds.",
        "child_allowed": "",
        "pets_allowed": "",
        "parking": ""
      }
    ],
    "sentiment_analysis": {
      "cons": [
        "Limited parking",
        "Expensive breakfast",
        "No spa services",
        "Dated rooms",
        "Uncomfortable beds",
        "Rude staff",
        "Noisy renovations",
        "Lack of basic amenities",
        "Overpriced rooms",
        "Limited food options",
        "Unsatisfactory value for money",
        "Heating issues",
        "Stained towels and bathrooms",
        "Delayed deposit refund"
      ],
      "pros": [
        "Location",
        "Friendly staff",
        "Near Times Square",
        "Clean rooms",
        "View",
        "Bed cleanliness"
      ],
      "categories": [
        {
          "name": "Cleanliness",
          "rating": 5.9,
          "description": "Mixed reviews on cleanliness with some guests mentioning dirty rugs, uncomfortable beds, and rude staff, while others appreciated the cleanliness of the rooms."
        },
        {
          "name": "Service",
          "rating": 7.6,
          "description": "Service was a point of contention, with some guests praising the friendly staff and the efforts to accommodate guests, but others complained about rude staff and long wait times for elevators."
        },
        {
          "name": "Location",
          "rating": 8.3,
          "description": "The hotel's location was a standout feature, with many guests appreciating its proximity to key landmarks and attractions."
        },
        {
          "name": "Room Quality",
          "rating": 4.9,
          "description": "Rooms received mixed reviews, with complaints about outdated rooms, uncomfortable beds, and noisy renovations, alongside positive comments about clean bedrooms and comfortable beds."
        },
        {
          "name": "Amenities",
          "rating": 6.7,
          "description": "Guests were divided on amenities, with some highlighting the lack of basic facilities like restaurant and lounges, while others appreciated the clean bedrooms and gym facilities."
        },
        {
          "name": "Value for Money",
          "rating": 5.5,
          "description": "Opinions on value for money were split, with some guests feeling the hotel was overpriced for the services offered, while others found it reasonable given the location."
        },
        {
          "name": "Food and Beverage",
          "rating": 6.9,
          "description": "Feedback on food and beverage services was mixed, with some guests criticizing the limited breakfast options, while others found it satisfactory."
        },
        {
          "name": "Overall Experience",
          "rating": 6.3,
          "description": "Most guests had a mixed experience, with some enjoying their stay and recommending the hotel, while others reported disappointing experiences."
        }
      ]
    },
    "sentiment_updated_at": "2026-07-08T14:33:49Z"
  }
};
